"use client";
import React, { useContext, useEffect, useState } from "react";

import { useLocalStorage } from "@/hooks/useLocalStorage";

type OngoingSessionValues = {
  /** Nome do cargo */
  name: string;
  /** Id do cargo */
  cargoId: string;
  /** Último do processo de abertura de vaga */
  step: number;
};

export type OngoingSessionContext = {
  values: OngoingSessionValues;
  setValues: (values: OngoingSessionValues) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const OngoingSessionContext = React.createContext<OngoingSessionContext>({
  values: {
    name: "",
    cargoId: "",
    step: 0,
  },
  setValues: () => null,
  open: false,
  setOpen: () => null,
});

export function OngoingSessionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [values, setValues] = useLocalStorage(
    "abertura-de-vagas-ongoing-session",
    {
      name: "",
      cargoId: "",
      step: 0,
    },
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const { cargoId, step, name } = values;
      if (cargoId !== "" && step > 0 && name !== "") {
        setOpen(true);
      }
    }, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OngoingSessionContext.Provider
      value={{ open, setOpen, values, setValues }}
    >
      {children}
    </OngoingSessionContext.Provider>
  );
}

export function useOngoingSessionContext() {
  const context = useContext(OngoingSessionContext);

  if (context === undefined) {
    throw new Error(
      "useOngoingSessionContext precisa estar dentro de OngoingSessionProvider",
    );
  }

  return useContext(OngoingSessionContext);
}
